module.exports = [
  {
    "id": 11697,
    "name": "GDPR conform / Retargeting: All Quiz Completers / More Energy / Advertorial"
  }
]
